import keyBy from "lodash/keyBy";

const COLORS = [
  { id: "-1", name: "[Unknown]", rgb: "0033B2" },
  { id: "0", name: "Black", rgb: "05131D" },
  { id: "1", name: "Blue", rgb: "0055BF" },
  { id: "2", name: "Green", rgb: "237841" },
  { id: "3", name: "Dark Turquoise", rgb: "008F9B" },
  { id: "4", name: "Red", rgb: "C91A09" },
  { id: "5", name: "Dark Pink", rgb: "C870A0" },
  { id: "6", name: "Brown", rgb: "583927" },
  { id: "7", name: "Light Gray", rgb: "9BA19D" },
  { id: "8", name: "Dark Gray", rgb: "6D6E5C" },
  { id: "9", name: "Light Blue", rgb: "B4D2E3" },
  { id: "10", name: "Bright Green", rgb: "4B9F4A" },
  { id: "11", name: "Light Turquoise", rgb: "55A5AF" },
  { id: "12", name: "Salmon", rgb: "F2705E" },
  { id: "13", name: "Pink", rgb: "FC97AC" },
  { id: "14", name: "Yellow", rgb: "F2CD37" },
  { id: "15", name: "White", rgb: "FFFFFF" },
  { id: "17", name: "Light Green", rgb: "C2DAB8" },
  { id: "18", name: "Light Yellow", rgb: "FBE696" },
  { id: "19", name: "Tan", rgb: "E4CD9E" },
  { id: "20", name: "Light Violet", rgb: "C9CAE2" },
  { id: "21", name: "Glow In Dark Opaque", rgb: "D4D5C9" },
  { id: "22", name: "Purple", rgb: "81007B" },
  { id: "23", name: "Dark Blue-Violet", rgb: "2032B0" },
  { id: "25", name: "Orange", rgb: "FE8A18" },
  { id: "26", name: "Magenta", rgb: "923978" },
  { id: "27", name: "Lime", rgb: "BBE90B" },
  { id: "28", name: "Dark Tan", rgb: "958A73" },
  { id: "29", name: "Bright Pink", rgb: "E4ADC8" },
  { id: "30", name: "Medium Lavender", rgb: "AC78BA" },
  { id: "31", name: "Lavender", rgb: "E1D5ED" },
  { id: "32", name: "Trans-Black IR Lens", rgb: "635F52" },
  { id: "33", name: "Trans-Dark Blue", rgb: "0020A0" },
  { id: "34", name: "Trans-Green", rgb: "84B68D" },
  { id: "35", name: "Trans-Bright Green", rgb: "D9E4A7" },
  { id: "36", name: "Trans-Red", rgb: "C91A09" },
  { id: "40", name: "Trans-Brown", rgb: "635F52" },
  { id: "41", name: "Trans-Light Blue", rgb: "AEEFEC" },
  { id: "42", name: "Trans-Neon Green", rgb: "F8F184" },
  { id: "43", name: "Trans-Very Lt Blue", rgb: "C1DFF0" },
  { id: "45", name: "Trans-Dark Pink", rgb: "DF6695" },
  { id: "46", name: "Trans-Yellow", rgb: "F5CD2F" },
  { id: "47", name: "Trans-Clear", rgb: "FCFCFC" },
  { id: "52", name: "Trans-Purple", rgb: "A5A5CB" },
  { id: "54", name: "Trans-Neon Yellow", rgb: "DAB000" },
  { id: "57", name: "Trans-Neon Orange", rgb: "FF800D" },
  { id: "60", name: "Chrome Antique Brass", rgb: "645A4C" },
  { id: "61", name: "Chrome Blue", rgb: "6C96BF" },
  { id: "62", name: "Chrome Green", rgb: "3CB371" },
  { id: "63", name: "Chrome Pink", rgb: "AA4D8E" },
  { id: "64", name: "Chrome Black", rgb: "1B2A34" },
  { id: "68", name: "Very Light Orange", rgb: "F3CF9B" },
  { id: "69", name: "Light Purple", rgb: "CD6298" },
  { id: "70", name: "Reddish Brown", rgb: "582A12" },
  { id: "71", name: "Light Bluish Gray", rgb: "A0A5A9" },
  { id: "72", name: "Dark Bluish Gray", rgb: "6C6E68" },
  { id: "73", name: "Medium Blue", rgb: "5A93DB" },
  { id: "74", name: "Medium Green", rgb: "73DCA1" },
  { id: "75", name: "Speckle Black-Copper", rgb: "05131D" },
  { id: "76", name: "Speckle DBGray-Silver", rgb: "6C6E68" },
  { id: "77", name: "Light Pink", rgb: "FECCCF" },
  { id: "78", name: "Light Nougat", rgb: "F6D7B3" },
  { id: "79", name: "Milky White", rgb: "FFFFFF" },
  { id: "80", name: "Metallic Silver", rgb: "A5A9B4" },
  { id: "81", name: "Metallic Green", rgb: "899B5F" },
  { id: "82", name: "Metallic Gold", rgb: "DBAC34" },
  { id: "84", name: "Medium Nougat", rgb: "AA7D55" },
  { id: "85", name: "Dark Purple", rgb: "3F3691" },
  { id: "86", name: "Light Brown", rgb: "7C503A" },
  { id: "89", name: "Royal Blue", rgb: "4C61DB" },
  { id: "92", name: "Nougat", rgb: "D09168" },
  { id: "100", name: "Light Salmon", rgb: "FEBABD" },
  { id: "110", name: "Violet", rgb: "4354A3" },
  { id: "112", name: "Medium Bluish Violet", rgb: "6874CA" },
  { id: "114", name: "Glitter Trans-Dark Pink", rgb: "DF6695" },
  { id: "115", name: "Medium Lime", rgb: "C7D23C" },
  { id: "117", name: "Glitter Trans-Clear", rgb: "FFFFFF" },
  { id: "118", name: "Aqua", rgb: "B3D7D1" },
  { id: "120", name: "Light Lime", rgb: "D9E4A7" },
  { id: "125", name: "Light Orange", rgb: "F9BA61" },
  { id: "129", name: "Glitter Trans-Purple", rgb: "A5A5CB" },
  { id: "132", name: "Speckle Black-Silver", rgb: "05131D" },
  { id: "133", name: "Speckle Black-Gold", rgb: "05131D" },
  { id: "134", name: "Copper", rgb: "AE7A59" },
  { id: "135", name: "Pearl Light Gray", rgb: "9CA3A8" },
  { id: "137", name: "Pearl Sand Blue", rgb: "7988A1" },
  { id: "142", name: "Pearl Light Gold", rgb: "DCBC81" },
  { id: "143", name: "Trans-Medium Blue", rgb: "CFE2F7" },
  { id: "148", name: "Pearl Dark Gray", rgb: "575857" },
  { id: "150", name: "Pearl Very Light Gray", rgb: "ABADAC" },
  { id: "151", name: "Very Light Bluish Gray", rgb: "E6E3E0" },
  { id: "158", name: "Yellowish Green", rgb: "DFEEA5" },
  { id: "178", name: "Flat Dark Gold", rgb: "B48455" },
  { id: "179", name: "Flat Silver", rgb: "898788" },
  { id: "182", name: "Trans-Orange", rgb: "F08F1C" },
  { id: "183", name: "Pearl White", rgb: "F2F3F2" },
  { id: "191", name: "Bright Light Orange", rgb: "F8BB3D" },
  { id: "212", name: "Bright Light Blue", rgb: "9FC3E9" },
  { id: "216", name: "Rust", rgb: "B31004" },
  { id: "226", name: "Bright Light Yellow", rgb: "FFF03A" },
  { id: "230", name: "Trans-Pink", rgb: "E4ADC8" },
  { id: "232", name: "Sky Blue", rgb: "7DBFDD" },
  { id: "236", name: "Trans-Light Purple", rgb: "96709F" },
  { id: "272", name: "Dark Blue", rgb: "0A3463" },
  { id: "288", name: "Dark Green", rgb: "184632" },
  { id: "294", name: "Glow In Dark Trans", rgb: "BDC6AD" },
  { id: "297", name: "Pearl Gold", rgb: "AA7F2E" },
  { id: "308", name: "Dark Brown", rgb: "352100" },
  { id: "313", name: "Maersk Blue", rgb: "3592C3" },
  { id: "320", name: "Dark Red", rgb: "720E0F" },
  { id: "321", name: "Dark Azure", rgb: "078BC9" },
  { id: "322", name: "Medium Azure", rgb: "36AEBF" },
  { id: "323", name: "Light Aqua", rgb: "ADC3C0" },
  { id: "326", name: "Olive Green", rgb: "9B9A5A" },
  { id: "334", name: "Chrome Gold", rgb: "BBA53D" },
  { id: "335", name: "Sand Red", rgb: "D67572" },
  { id: "351", name: "Medium Dark Pink", rgb: "F785B1" },
  { id: "366", name: "Earth Orange", rgb: "FA9C1C" },
  { id: "373", name: "Sand Purple", rgb: "845E84" },
  { id: "378", name: "Sand Green", rgb: "A0BCAC" },
  { id: "379", name: "Sand Blue", rgb: "6074A1" },
  { id: "383", name: "Chrome Silver", rgb: "E0E0E0" },
  { id: "450", name: "Fabuland Brown", rgb: "B67B50" },
  { id: "462", name: "Medium Orange", rgb: "FFA70B" },
  { id: "484", name: "Dark Orange", rgb: "A95500" },
  { id: "503", name: "Very Light Gray", rgb: "E6E3DA" },
  { id: "1000", name: "Glow in Dark White", rgb: "D9D9D9" },
  { id: "1001", name: "Medium Violet", rgb: "9391E4" },
  { id: "1002", name: "Glitter Trans-Neon Green", rgb: "C0F500" },
  { id: "1003", name: "Glitter Trans-Light Blue", rgb: "68BCC5" },
  { id: "1004", name: "Trans-Flame Yellowish Orange", rgb: "FCB76D" },
  { id: "1005", name: "Trans-Fire Yellow", rgb: "FBE890" },
  { id: "1006", name: "Trans-Light Royal Blue", rgb: "B4D4F7" },
  { id: "1007", name: "Reddish Lilac", rgb: "8E5597" },
  { id: "1008", name: "Vintage Blue", rgb: "039CBD" },
  { id: "1009", name: "Vintage Green", rgb: "1E601E" },
  { id: "1010", name: "Vintage Red", rgb: "CA1F08" },
  { id: "1011", name: "Vintage Yellow", rgb: "F3C305" },
  { id: "1012", name: "Fabuland Orange", rgb: "EF9121" },
  { id: "1013", name: "Modulex White", rgb: "F4F4F4" },
  { id: "1014", name: "Modulex Light Bluish Gray", rgb: "AfB5C7" },
  { id: "1015", name: "Modulex Light Gray", rgb: "9C9C9C" },
  { id: "1016", name: "Modulex Charcoal Gray", rgb: "595D60" },
  { id: "1017", name: "Modulex Tile Gray", rgb: "6B5A5A" },
  { id: "1018", name: "Modulex Black", rgb: "4D4C52" },
  { id: "1019", name: "Modulex Tile Brown", rgb: "330000" },
  { id: "1020", name: "Modulex Terracotta", rgb: "5C5030" },
  { id: "1021", name: "Modulex Brown", rgb: "907450" },
  { id: "1022", name: "Modulex Buff", rgb: "DEC69C" },
  { id: "1023", name: "Modulex Red", rgb: "B52C20" },
  { id: "1024", name: "Modulex Pink Red", rgb: "F45C40" },
  { id: "1025", name: "Modulex Orange", rgb: "F47B30" },
  { id: "1026", name: "Modulex Light Orange", rgb: "F7AD63" },
  { id: "1027", name: "Modulex Light Yellow", rgb: "FFE371" },
  { id: "1028", name: "Modulex Ochre Yellow", rgb: "FED557" },
  { id: "1029", name: "Modulex Lemon", rgb: "BDC618" },
  { id: "1030", name: "Modulex Pastel Green", rgb: "7DB538" },
  { id: "1031", name: "Modulex Olive Green", rgb: "7C9051" },
  { id: "1032", name: "Modulex Aqua Green", rgb: "27867E" },
  { id: "1033", name: "Modulex Teal Blue", rgb: "467083" },
  { id: "1034", name: "Modulex Tile Blue", rgb: "0057A6" },
  { id: "1035", name: "Modulex Medium Blue", rgb: "61AFFF" },
  { id: "1036", name: "Modulex Pastel Blue", rgb: "68AECE" },
  { id: "1037", name: "Modulex Violet", rgb: "BD7D85" },
  { id: "1038", name: "Modulex Pink", rgb: "F785B1" },
  { id: "1039", name: "Modulex Clear", rgb: "FFFFFF" },
  { id: "1040", name: "Modulex Foil Dark Gray", rgb: "595D60" },
  { id: "1041", name: "Modulex Foil Light Gray", rgb: "9C9C9C" },
  { id: "1042", name: "Modulex Foil Dark Green", rgb: "006400" },
  { id: "1043", name: "Modulex Foil Light Green", rgb: "7DB538" },
  { id: "1044", name: "Modulex Foil Dark Blue", rgb: "0057A6" },
  { id: "1045", name: "Modulex Foil Light Blue", rgb: "68AECE" },
  { id: "1046", name: "Modulex Foil Violet", rgb: "4B0082" },
  { id: "1047", name: "Modulex Foil Red", rgb: "8B0000" },
  { id: "1048", name: "Modulex Foil Yellow", rgb: "FED557" },
  { id: "1049", name: "Modulex Foil Orange", rgb: "F7AD63" },
  { id: "1050", name: "Coral", rgb: "FF698F" },
  { id: "1051", name: "Pastel Blue", rgb: "5AC4DA" },
  { id: "1052", name: "Glitter Trans-Orange", rgb: "F08F1C" },
  { id: "1053", name: "Opal Trans-Light Blue", rgb: "68BCC5" },
  { id: "1054", name: "Opal Trans-Dark Pink", rgb: "CE1D9B" },
  { id: "1055", name: "Opal Trans-Clear", rgb: "FCFCFC" },
  { id: "1056", name: "Opal Trans-Brown", rgb: "583927" },
  { id: "1057", name: "Trans-Light Bright Green", rgb: "C9E788" },
  { id: "1058", name: "Trans-Light Green", rgb: "94E5AB" },
  { id: "1059", name: "Opal Trans-Purple", rgb: "8320B7" },
  { id: "1060", name: "Opal Trans-Bright Green", rgb: "84B68D" },
  { id: "1061", name: "Opal Trans-Dark Blue", rgb: "0020A0" },
  { id: "1062", name: "Vibrant Yellow", rgb: "EBD800" },
  { id: "1063", name: "Pearl Copper", rgb: "B46A00" },
  { id: "1064", name: "Fabuland Red", rgb: "FF8014" },
  { id: "1065", name: "Reddish Gold", rgb: "AC8247" },
  { id: "1066", name: "Curry", rgb: "DD982E" },
  { id: "1067", name: "Dark Nougat", rgb: "AD6140" },
  { id: "1068", name: "Bright Reddish Orange", rgb: "EE5434" },
  { id: "1069", name: "Pearl Red", rgb: "D60026" },
  { id: "1070", name: "Pearl Blue", rgb: "0059A3" },
  { id: "1071", name: "Pearl Green", rgb: "008E3C" },
  { id: "1072", name: "Pearl Brown", rgb: "57392C" },
  { id: "1073", name: "Pearl Black", rgb: "0A1327" },
  { id: "1074", name: "Duplo Blue", rgb: "009ECE" },
  { id: "1075", name: "Duplo Medium Blue", rgb: "3E95B6" },
  { id: "1076", name: "Duplo Lime", rgb: "FFF230" },
  { id: "1077", name: "Fabuland Lime", rgb: "78FC78" },
  { id: "1078", name: "Duplo Medium Green", rgb: "468A5F" },
  { id: "1079", name: "Duplo Light Green", rgb: "60BA76" },
  { id: "1080", name: "Light Tan", rgb: "F3C988" },
  { id: "1081", name: "Rust Orange", rgb: "872B17" },
  { id: "1082", name: "Clikits Pink", rgb: "FE78B0" },
  { id: "1083", name: "Two-tone Copper", rgb: "945148" },
  { id: "1084", name: "Two-tone Gold", rgb: "AB673A" },
  { id: "1085", name: "Two-tone Silver", rgb: "737271" },
  { id: "1086", name: "Pearl Lime", rgb: "6A7944" },
  { id: "1087", name: "Duplo Pink", rgb: "FF879C" },
  { id: "1088", name: "Medium Brown", rgb: "755945" },
  { id: "1089", name: "Warm Tan", rgb: "CCA373" },
  { id: "1090", name: "Duplo Turquoise", rgb: "3FB69E" },
  { id: "1091", name: "Warm Yellowish Orange", rgb: "FFCB78" },
  { id: "1092", name: "Metallic Copper", rgb: "764D3B" },
  { id: "1093", name: "Light Lilac", rgb: "9195CA" },
  { id: "1094", name: "Trans-Medium Purple", rgb: "8D73B3" },
  { id: "1095", name: "Trans-Black", rgb: "635F52" },
  { id: "1096", name: "Glitter Trans-Bright Green", rgb: "D9E4A7" },
  { id: "1097", name: "Glitter Trans-Medium Purple", rgb: "8D73B3" },
  { id: "1098", name: "Glitter Trans-Green", rgb: "84B68D" },
  { id: "1099", name: "Glitter Trans-Pink", rgb: "E4ADC8" },
  { id: "1100", name: "Clikits Yellow", rgb: "FFCF0B" },
  { id: "1101", name: "Duplo Dark Purple", rgb: "5F27AA" },
  { id: "1102", name: "Trans-Neon Red", rgb: "FF0040" },
  { id: "1103", name: "Pearl Titanium", rgb: "3E3C39" },
  { id: "1104", name: "HO Aqua", rgb: "B3D7D1" },
  { id: "1105", name: "HO Azure", rgb: "1591cb" },
  { id: "1106", name: "HO Blue-gray", rgb: "354e5a" },
  { id: "1107", name: "HO Cyan", rgb: "5b98b3" },
  { id: "1108", name: "HO Dark Aqua", rgb: "a7dccf" },
  { id: "1109", name: "HO Dark Blue", rgb: "0A3463" },
  { id: "1110", name: "HO Dark Gray", rgb: "6D6E5C" },
  { id: "1111", name: "HO Dark Green", rgb: "184632" },
  { id: "1112", name: "HO Dark Lime", rgb: "b2b955" },
  { id: "1113", name: "HO Dark Red", rgb: "631314" },
  { id: "1114", name: "HO Dark Sand Green", rgb: "627a62" },
  { id: "1115", name: "HO Dark Turquoise", rgb: "10929d" },
  { id: "1116", name: "HO Earth Orange", rgb: "bb771b" },
  { id: "1117", name: "HO Gold", rgb: "b4a774" },
  { id: "1118", name: "HO Light Aqua", rgb: "a3d1c0" },
  { id: "1119", name: "HO Light Brown", rgb: "965336" },
  { id: "1120", name: "HO Light Gold", rgb: "cdc298" },
  { id: "1121", name: "HO Light Tan", rgb: "f9f1c7" },
  { id: "1122", name: "HO Light Yellow", rgb: "f5fab7" },
  { id: "1123", name: "HO Medium Blue", rgb: "7396c8" },
  { id: "1124", name: "HO Medium Red", rgb: "c01111" },
  { id: "1125", name: "HO Metallic Blue", rgb: "0d4763" },
  { id: "1126", name: "HO Metallic Dark Gray", rgb: "5e5e5e" },
  { id: "1127", name: "HO Metallic Green", rgb: "879867" },
  { id: "1128", name: "HO Metallic Sand Blue", rgb: "5f7d8c" },
  { id: "1129", name: "HO Olive Green", rgb: "9B9A5A" },
  { id: "1130", name: "HO Rose", rgb: "d06262" },
  { id: "1131", name: "HO Sand Blue", rgb: "6e8aa6" },
  { id: "1132", name: "HO Sand Green", rgb: "A0BCAC" },
  { id: "1133", name: "HO Tan", rgb: "E4CD9E" },
  { id: "1134", name: "HO Titanium", rgb: "616161" },
  { id: "1135", name: "Metal", rgb: "A5ADB4" },
  { id: "1136", name: "Reddish Orange", rgb: "CA4C0B" },
  { id: "1137", name: "Sienna Brown", rgb: "915C3C" },
  { id: "1138", name: "Umber Brown", rgb: "5E3F33" },
  { id: "1139", name: "Opal Trans-Yellow", rgb: "F5CD2F" },
  { id: "1140", name: "Neon Orange", rgb: "EC4612" },
  { id: "1141", name: "Neon Green", rgb: "D2FC43" },
  { id: "1142", name: "Dark Olive Green", rgb: "5d5c36" },
  { id: "1143", name: "Glitter Milky White", rgb: "FFFFFF" },
  { id: "1144", name: "Chrome Red", rgb: "CE3021" },
  { id: "1145", name: "Ochre Yellow", rgb: "DD9E47" },
  { id: "9999", name: "[No Color/Any Color]", rgb: "05131D" },
];
const COLORS_BY_ID = keyBy(COLORS, "id");

export { COLORS, COLORS_BY_ID };
